import React from "react";
import { Col } from "react-bootstrap";
import Select from "react-select";
import countries from "../information/countries.json";
import AnimateWrapper from "../util/AnimateWrapper";
import BasicQuestion from "../util/BasicQuestion";
import { useBreadcrumbs } from "../util/BreadcrumbContext";
import ChoiceCard from "../util/ChoiceCard";

const CountryTo = () => {
    const { addBreadcrumb } = useBreadcrumbs();

    return (
        <AnimateWrapper>
            <BasicQuestion
                question="Waar wilt u het pakket naar versturen?"
                answers={
                    <>
                        <Col xs={12} sm={4}>
                            <ChoiceCard
                                body="Binnen de EU"
                                onClick={() =>
                                    addBreadcrumb(
                                        {
                                            href: "/no-proforma",
                                            text: "Geen proforma"
                                        },
                                        {
                                            countryTo: "EU"
                                        }
                                    )
                                }
                            />
                        </Col>
                        <Col xs={12} sm={4}>
                            <ChoiceCard
                                header="Anders"
                                body={
                                    <div className="w-100">
                                        <Select
                                            options={Object.entries(
                                                countries
                                            ).map(([k, v]) => ({
                                                label: v.full_name,
                                                value: k
                                            }))}
                                            onChange={({ label, value }) => {
                                                addBreadcrumb(
                                                    {
                                                        href: `/country/${value}`,
                                                        text: label
                                                    },
                                                    { countryTo: value }
                                                );
                                            }}
                                        />
                                    </div>
                                }
                            />
                        </Col>
                        <Col xs={12} sm={4}>
                            <ChoiceCard
                                body="Het land staat er niet tussen"
                                onClick={() =>
                                    addBreadcrumb(
                                        {
                                            href: "/country-not-supported",
                                            text: "Land niet ondersteund"
                                        },
                                        {
                                            countryTo: "EU"
                                        }
                                    )
                                }
                            />
                        </Col>
                    </>
                }
            />
        </AnimateWrapper>
    );
};

export default CountryTo;
